import MainContainer from '@blocks/MainContainer'
import useSalonController from '@customer/api/useSalonController'
import useAuth from '@hooks/useAuth'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import useCurrentArchive from './hooks/useCurrentArchive'

export default function CurrentPage() {
    const { user } = useAuth()
    const controller = useSalonController()
    const salons = controller.current.use(`customer:${user.id}:current`)

    useTitle("Open Salons")
    useMainTemplate({ category: "current" })
    
    const archive = useCurrentArchive(salons.data)
    
    return <MainContainer heading="Open Salons" box={false}>{archive.element}</MainContainer>
}